import { DateTime } from "luxon";
import { existValueAndEmptyString } from "@/lib/util";

export class JobDetailPresenter {
  constructor(appointment) {
    const latitude = appointment.project.latitude || null;
    const longitude = appointment.project.longitude || null;
    const latLng =
      latitude && longitude
        ? `https://www.google.com/maps?q=${appointment.project.project_name}&ll=${appointment.project.latitude},${appointment.project.longitude}&z=15&markers=${appointment.project.latitude},${appointment.project.longitude}&iwloc=near`
        : null;
    const providerFulfilledAt = appointment.provider_fulfilled_at || null;
    const providerFulfilledAtDateTimeFormat = providerFulfilledAt
      ? DateTime.fromISO(providerFulfilledAt).toUTC()
      : null;
    const providerFulfilledImages = appointment.provider_fulfilled_image_urls
      ? appointment.provider_fulfilled_image_urls.filter(image =>
          existValueAndEmptyString(image)
        )
      : [];
      const fullAddressText = [
        appointment.home.address_no,
        appointment.project.project_name,
        appointment.project.full_address_text
      ].filter(text => text).join(' ');

    const detail = {
      id: appointment.id,
      idForRedirectPage: appointment.appointment_id_for_redirect_page || null,
      subscriptionMemberId: appointment.subscription_member_id || null,
      status: appointment.status,
      dateTime: DateTime.fromISO(appointment.date_time).toUTC(),
      dateTimeEnd: appointment.date_time_end
        ? DateTime.fromISO(appointment.date_time_end).toUTC()
        : null,
      confirmedAt: DateTime.fromISO(appointment.confirmed_at).toUTC(),
      providerFulfilledAt: providerFulfilledAtDateTimeFormat,
      providerFulfilledMessage: appointment.provider_fulfilled_detail,
      providerFulfilledImages:
        providerFulfilledImages.length > 0 ? providerFulfilledImages : null,
      service: {
        id: appointment.service.id.toString(),
        name: appointment.service.name,
        subscriptionId: appointment.service.subscription_id
      },
      home: {
        fullAddressText: fullAddressText,
        latLng: latLng,
        contact: {
          name: `${appointment.user.first_name} ${appointment.user.last_name}`,
          phoneNumber: appointment.user.mobile_number || "-"
        }
      },
      constraint: {
        canConfirm: appointment.constraint.can_confirm_appointment,
        canProviderFulfill:
          appointment.constraint.can_provider_confirm_service_complete,
        canChangeDate: appointment.constraint.can_change_appointment_date
      },
      note: appointment.note || "-",
      appointmentNo: appointment.appointment_no,
      quantity: appointment.quantity,
    };

    this.appointment = detail;
  }
}



// WEBPACK FOOTER //
// ./src/components/other-web/supplier/presenters/JobDetailPresenter.js